import { ValidationResult } from '../types';

const BLOCKED_WORDS = new Set(['a', 'i']);

const COMMON_WORDS = new Set([
  // 2-letter
  'to', 'it', 'is', 'at', 'on', 'in', 'up', 'we', 'he', 
  'me', 'my', 'no', 'so', 'do', 'go', 'or', 'if', 'of',
  // 3-letter
  'the', 'and', 'for', 'are', 'but', 'not', 'you', 'all',
  'can', 'had', 'her', 'was', 'one', 'our', 'out', 'day',
  'get', 'has', 'him', 'his', 'how', 'its', 'may', 'new',
  'now', 'old', 'see', 'two', 'way', 'who', 'boy', 'did',
  'let', 'put', 'say', 'she', 'too', 'use'
]);

const COMMON_PREFIXES = new Set([
  'con', 'pre', 'pro', 'dis', 'mis', 'non', 'sub', 'per', 'com'
]);

export function validateShortcut(shortcut: string): ValidationResult {
  const lower = shortcut.toLowerCase();
  
  if (BLOCKED_WORDS.has(lower)) {
    return { 
      valid: false, 
      severity: 'error', 
      message: 'Single letters are not allowed as shortcuts' 
    };
  }
  
  if (COMMON_WORDS.has(lower)) {
    return { 
      valid: true, 
      severity: 'warning', 
      message: `"${shortcut}" is a common word. This may cause unintended expansions.` 
    };
  }
  
  if (COMMON_PREFIXES.has(lower)) {
    return { 
      valid: true, 
      severity: 'info', 
      message: `"${shortcut}" is a common prefix. Consider a more unique shortcut.` 
    };
  }
  
  return { valid: true, severity: null, message: null };
}